import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeBanner from "./sections/WelcomeBanner";
import AboutUs from "./sections/AboutUs";
import PhotoAlbum from "./sections/PhotoAlbum";
import OurEngineeringServices from "./sections/OurEngineeringServices";
import FeaturedProjects from "./sections/FeaturedProjects";
import ContactDetails from "./sections/ContactDetails";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeBanner />
      <AboutUs />
      <PhotoAlbum />
      <OurEngineeringServices />
      <FeaturedProjects />
      <ContactDetails />
      <Contact />
      <Footer />
    </div>;
}